<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
 
          <div style="margin-bottom: 10px;text-align: left;">
            <lay-button size="sm" @click="changeVisible11" type="primary">新增</lay-button>
          </div>
  
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">  
  
            <template v-slot:operator="{ row }">
              <lay-button size="xs" type="danger" @click="deleUpdateLog(row)">删除</lay-button>
            </template>
          </lay-table>
  
  
  
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
    <lay-layer v-model="visible11" :shade="false" :area="['400px', '300px']" :btn="action11" title="添加/修改">
      <div style="padding: 20px;">
       <lay-form :model="advertise" ref="layFormRef11" > 
        <lay-form-item prop="key">
               <lay-textarea placeholder="请输入更新内容" v-model="advertise.key"></lay-textarea>
       </lay-form-item>
           </lay-form>
      </div>
    </lay-layer>
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allUpdateLog, addUpdateLog,delUpdateLog} from '../../api'
 
   
   
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
   { title: "序号", key: "id", align: "center" },  
    { title: "标题", key: "content", align: "center" },  
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllallUpdateLog = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit };
    allUpdateLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllallUpdateLog();
  
  
  const change = (page: any) => {
    getAllallUpdateLog();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 
 

  
  const advertise = reactive({
    id:0,
    key: ""
  })
  
  
  const deleUpdateLog = (row: any) => {
       var data={'id':row.id} 
    delUpdateLog(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllallUpdateLog(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  
  const changeVisible11 = () => {
    advertise.id = 0;
    advertise.key = ""; 
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addUpdateLog(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllallUpdateLog();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false; 
  
      }
    }
  ])
  
  
  </script>
  
  <style scoped></style>